import { makeObservable, override } from 'mobx';

import { t } from '@gem/modules/i18n';

import { IGroupData } from 'APP/model/group/groupModel.types';
import { Root } from 'STORE';
import { Groups } from 'STORE/Groups/Groups';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';

import { Group } from '../Group';

export class ServiceMessages extends Group {
  constructor(group: IGroupData, groups: Groups, root: Root) {
    super(group, groups, root);
    makeObservable(this);
    this.name = t('service_messages_title') as string;
    this.description = t('service_messages_access_request') as string;
    this.muted = false;
  }

  get isServiceMessages(): boolean {
    return true;
  }

  @override
  get avatarTitle(): string {
    return t('service_messages_title');
  }

  @override
  get hasDraft(): boolean {
    return false;
  }

  @override
  get inputPanel(): InputPanel {
    return null as unknown as InputPanel;
  }

  @override
  get deepLink(): null {
    return null;
  }

  @override
  get canInviteUsers(): boolean {
    return false;
  }

  @override
  get canLeaveComment(): boolean {
    return false;
  }

  @override
  get canInitConference(): boolean {
    return (
      this.withMeInAdmins ||
      (this.isMember && Boolean(this.memberCustomPermissions?.canInitConference))
    );
  }

  @override
  get canInitCall(): boolean {
    return false;
  }

  @override
  get canDisplayMembers(): boolean {
    return false;
  }

  get canMentionAll(): boolean {
    return false;
  }

  get canBeScheduled(): boolean {
    return false;
  }

  @override
  get isShowDraft(): boolean {
    return false;
  }
}
